/**
 * The external dependencies.
 */
import React from 'react';
import {connect} from 'react-redux';
import styled from 'styled-components';
/**
 * The internal dependencies.
 */
import {convertToItems} from '../../../../common/utilities';
import InputList from '../../../../components/general/input-list';
import Button from '../../../../components/task/shop/form/button';
import {getTasksCurrent, getTaskWorkSteps} from "../../../../store/tasks/selectors";
import {displaycurrentstep, randomWorksteps} from "../../../../store/auth/selectors";

const WrapperWrapper = styled.div`
	background: #fff;
	padding: 13px 19px;
	border-radius: 8px;
	border: 1px solid #d9d7d7;
	box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
`;

const StepsInput = ({
                        data,
                        handleSelect,
                        steps,
                        handleComplete,
                        currentTask,
                        randomWorksteps,
                        displaycurrentstep,
                    }) => {
    const pluckStepNumber = (val) => val.selectionorder;//val.replace(/(\d).*/, '$1');
    return (
        <WrapperWrapper>
            <InputList
                items={convertToItems(
                    steps,
                    data.value,
                    (item, val) => pluckStepNumber(item) === val
                )}
                handleClick={(val) => handleSelect(pluckStepNumber(val))}
                currentTask={currentTask}
                randomWorksteps={randomWorksteps}
                displaycurrentstep={displaycurrentstep}
            />

            <Button handleClick={() => handleComplete(data)} width="100%"/>
        </WrapperWrapper>
    );
};

export default connect(
    (state) => ({
        steps: getTaskWorkSteps(state),
        currentTask: getTasksCurrent(state),
        randomWorksteps: randomWorksteps(state),
        displaycurrentstep: displaycurrentstep(state),
    })
)(StepsInput);



// WEBPACK FOOTER //
// ./src/components/task/shop/form/steps-input.js